// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDiqi182z7SCbsIJYwgczcr6n3F2eFohfk",
  authDomain: "kolaycafe.firebaseapp.com",
  projectId: "kolaycafe",
  storageBucket: "kolaycafe.firebasestorage.app",
  messagingSenderId: "392580067246",
  appId: "1:392580067246:web:24a394beb150133199a23f",
  measurementId: "G-EJ26DF0PQP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firebase Cloud Messaging Instance
export const messaging = getMessaging(app);

// Register the service worker correctly
navigator.serviceWorker
  .register("/firebase-messaging-sw.js")
  .then((registration) => {
    console.log("Service Worker registered:", registration);
  })
  .catch((error) => {
    console.error("Service Worker registration failed:", error);
  });

// Request permission for notifications
export const requestForToken = async () => {
  try {
    const registration = await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey:
        "BFSLEy56sZinGaPVKavSm-M7H-tNIetGUgTfg9f5xJ8iyhw-UVL-OrqkVbBU3d3piJHlq_EQN-YeYYMXPdDZM2g",
      serviceWorkerRegistration: registration,
    });
    if (token) {
      console.log("FCM Token:", token);
    } else {
      console.log(
        "No registration token available. Request permission to generate one."
      );
    }
  } catch (error) {
    console.error("Error getting FCM token:", error);
  }
};

// Listen for incoming messages
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Push Notification Received: ", payload);
      resolve(payload);
    });
  });

export default app;
